import { BizAppConfig } from 'config/application.manifest';
import { createAppRequest } from '@/services/request';
import type {
  FamsLongTermPerformanceQueryParams,
  FamsLongTermPerformanceResponse,
} from './types/long-term-performance';

const request = createAppRequest();

const withAppApiBaseUrl = (url: string) => {
  const baseUrl =
    BizAppConfig.appApiUrl ||
    (typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname) &&
    window.location.port === '8000'
      ? 'http://localhost:3004'
      : '');
  if (!baseUrl) return url;
  return `${baseUrl.replace(/\/+$/g, '')}${url}`;
};

export async function getFamsLongTermPerformance(
  params?: FamsLongTermPerformanceQueryParams,
) {
  return request<FamsLongTermPerformanceResponse>(
    withAppApiBaseUrl('/bff/fams/long-term-performance'),
    { method: 'GET', params },
  );
}
